import { ITEM_STATE_LOADING } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_LOADING;
